import React, { Suspense, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'ck-ui';

const TrendingProducts = React.lazy(() => import('./TrendingProducts').then(module => ({ default: module.TrendingProducts })));
const RecommendedProducts = React.lazy(() => import('./RecommendedProducts').then(module => ({ default: module.RecommendedProducts })));
const RecentlyViewedProducts = React.lazy(() => import('./RecentlyViewedProducts').then(module => ({ default: module.RecentlyViewedProducts })));

const LazyLoadRecommendation = (props) => {
  const { model } = props;
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  // Lazyload RecommendedProducts or TrendingProducts Observer
  useEffect(() => {
    const lazyloadObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.unobserve(ref.current);
        }
      });
    }, { rootMargin: '150px' });
    lazyloadObserver.observe(ref.current);

    return () => {
      lazyloadObserver.disconnect();
    };
  }, []);

  return (
    <div ref={ref}>
      {show && (
        <Suspense fallback={<Loading isLoading mobileHeight="120vw" height="395px" />}>
          {/* eslint-disable-next-line no-nested-ternary */}
          {model === 'trending-items'
            ? (<TrendingProducts {...props} />)
            : model === 'recently-viewed' ? (<RecentlyViewedProducts {...props} />) : (<RecommendedProducts {...props} />)}
        </Suspense>
      )}
    </div>
  );
};

LazyLoadRecommendation.propTypes = {
  model: PropTypes.string.isRequired
};

export { LazyLoadRecommendation };
